import React, { useState, useEffect, useRef } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  Filter,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import Table from "../../core/pagination/datatable";
import Axios from "axios";
import { setindentlist_data } from "../../core/redux/action";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  API_BASE_URL,
  DOWNLD_EXCEL,
  GET_VSTORE_PROD,
  GET_STOCK_INDENT,
  GET_STOCK_INDENT_LIST,
  INSERT_STOCK_INDENT,
  UPLOAD_EXCEL,
  GET_USER_STORES,
  GET_INDENT_BTN_STATUS,
  DELETE_INDENT,
} from "../../Config";
import "../../style/css/loader.css";
import Swal from "sweetalert2";
import { getUserPermissions } from "../../UserPermissions";
import ViewIndent from "../../core/modals/purchases/viewindent";
import withReactContent from "sweetalert2-react-content";
import ApplyLateIndentReq from "../dashboard/lateindentrequestapply";

const Indent = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [loading, setLoading] = useState(false);
  const [excelErrorMess, setExcelErrorMess] = useState("");
  const [editSubmitLoading, setEditSubmitLoading] = useState(false);
  const [addBtnStatus, setAddBtnStatus] = useState(null);
  const [offcanvasWidth, setOffcanvasWidth] = useState("50%");
  const navigate = useNavigate();
  const [storeData, setStoreData] = useState([]);
  const [productsData, setProductsData] = useState([]);

  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedFilterStore, setSelctedFilterStore] = useState(null);
  const [selectedFilterStatus, setSelectedFilterStatus] = useState(null);
  const [indentProducts, setIndentProducts] = useState([]);
  const [selectedFilterDate, setSelectedFilterDate] = useState(null);

  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);

  const [selectedProducts, setSelectedProducts] = useState([]);

  const [editObj, setEditObj] = useState([]);
  const [viewObj, setViewObj] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
  const [draftEditBtnLoading, setDraftEditBtnLoading] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isDisplayProduct, setIsDisplayProduct] = useState(true);
  const [isDisplayExcel, setIsDisplayExcel] = useState(false);
  const [isDisplayProductBtn, setIsDisplayProductBtn] = useState(true);
  const [isDisplayExcelBtn, setIsDisplayExcelBtn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [project, setProject] = useState("");
  const [location, setLocation] = useState("");
  const [notes, setNotes] = useState("");
  const [editProject, setEditProject] = useState("");
  const [editLocation, setEditLocation] = useState("");
  const [editNotes, setEditNotes] = useState("");
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProjectOption, setSelectedProjectOption] = useState(null);

  const [indentPrintData, setIndentPrintData] = useState([]);
  const [isPrintTriggered, setIsPrintTriggered] = useState(false);
  const printRef = useRef();

  // #region Session userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  const [permissions, setPermissions] = useState({
    isRead: "d-none",
    isWrite: "d-none",
    isDelete: "d-none",
    isExport: "d-none",
  });

  useEffect(() => {
    const perms = getUserPermissions("Indent");
    setPermissions(perms);
  }, []);

  const canViewRateAndTotal = [1, 2].includes(Number(userDataSession?.RoleId));
  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`,
      )
        .then((response) => {
          if (response.data) {
            setStoreData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  const formatIndianCurrency = (value) => {
    if (value === null || value === undefined || isNaN(value)) return "0.00";

    const number = Number(value);
    const [integerPart, decimalPart] = number.toFixed(2).split(".");

    // Indian formatting
    let lastThree = integerPart.substring(integerPart.length - 3);
    let otherNumbers = integerPart.substring(0, integerPart.length - 3);

    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }

    const formattedInteger =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

    return `${formattedInteger}.${decimalPart}`;
  };

  useEffect(() => {
    if (storeData.length === 1) {
      const selectedStoreObj = {
        value: storeData[0].StoreId,
        label: storeData[0].Name,
      };
      setSelectedStore(selectedStoreObj);
      setSelctedFilterStore(selectedStoreObj);
    }
  }, [storeData]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_INDENT_BTN_STATUS}?OrgId=${userDataSession.OrgId}&StoreId=${userDataSession?.StoreId}`,
      )
        .then((response) => {
          if (response.data) {
            console.log(response.data, "response of IsIndentDayToday");
            setAddBtnStatus(response.data.ResultData[0].IsIndentDayToday);
          } else {
            console.error(
              "Error fetching data GET_INDENT_BTN_STATUS:",
              response.data,
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching data GET_INDENT_BTN_STATUS:", error);
        });
    }
  }, [userDataSession]);
  useEffect(() => {
    if (userDataSession?.OrgId) {
      Axios.get(
        `${API_BASE_URL}Inventory/getIndentProject?OrgId=${userDataSession.OrgId}`,
      )
        .then((response) => {
          if (response.data?.Status && response.data.ResultData) {
            const options = response.data.ResultData.map((item) => ({
              value: item.Project,
              label: item.Project,
            }));
            setProjectOptions(options);
          }
        })
        .catch((error) => {
          console.error("Error fetching projects:", error);
        });
    }
  }, [userDataSession]);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const dataSource = useSelector((state) => state.indentlist_data) || [];
  const truncateText = (text, maxLength = 30) => {
    if (!text || text.length <= maxLength) return text;

    const chars = Math.floor((maxLength - 3) / 2);

    return `${text.slice(0, chars)}...${text.slice(-chars)}`;
  };
  const fetchStockIndentList = () => {
    setLoading(true);
    const api = `${API_BASE_URL}${GET_STOCK_INDENT}?OrgId=${userDataSession.OrgId}&StoreId=0&IndentDt=0&UserId=${userDataSession.UserId}&Status=0&Type=0`;
    Axios.get(api)
      .then((response) => {
        if (response.data.Status) {
          dispatch(setindentlist_data(response.data.ResultData));
        } else {
          console.error("Error fetching data:", response.data.Message);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      fetchStockIndentList();
    }
  }, [userDataSession]);

  const indStatusOptions = [
    { value: "0", label: "All" },
    { value: "1", label: "Draft" },
    { value: "2", label: "Sent" },
    { value: "3", label: "Approved" },
    { value: "4", label: "Reject" },
    { value: "5", label: "Completed" },
  ];

  // #region Getting Indents by filters
  const fetchFilterData = () => {
    if (
      userDataSession &&
      userDataSession.OrgId &&
      (selectedFilterStore || selectedFilterDate || selectedFilterStatus)
    ) {
      setLoading(true);
      let indentdate = 0;
      let storeid = 0;
      let status = 0;

      if (selectedFilterStore) {
        storeid = selectedFilterStore.value;
      }
      if (selectedFilterDate) {
        indentdate = selectedFilterDate;
      }
      if (selectedFilterStatus) {
        status = selectedFilterStatus.value;
      }
      const api = `${API_BASE_URL}${GET_STOCK_INDENT}?OrgId=${userDataSession.OrgId}&StoreId=${storeid}&IndentDt=${indentdate}&UserId=${userDataSession.UserId}&Status=${status}&Type=0`;
      console.log(api);
      Axios.get(api)
        .then((response) => {
          if (response.data.Status) {
            dispatch(setindentlist_data(response.data.ResultData));
            setLoading(false);
          } else {
            dispatch(setindentlist_data(response.data.ResultData));
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          dispatch(setindentlist_data([]));
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  };

  const handleFilterDateChange = (event) => {
    setSelectedFilterDate(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleStoreFilterChange = (selectedOption) => {
    setSelctedFilterStore(selectedOption);
  };

  const handleStatusFilterChange = (selectedOption) => {
    setSelectedFilterStatus(selectedOption);
  };

  // #region Getting Store Products
  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && selectedStore) {
      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: "0",
        IsActive: 1,
        ProductId: 0,
        StoreId: selectedStore ? selectedStore.value : 0,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 1,
      };
      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          if (response.data) {
            setProductsData(response.data.ResultData);
          } else {
            setProductsData([]);
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          setProductsData([]);
          console.error("Error fetching data:", error);
        });
    }
  }, [selectedStore]);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );

  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const statusOrder = {
    1: "Draft",
    2: "Sent",
    3: "Approved",
    4: "Reject",
    5: "Completed",
  };

  const statusClassNames = {
    1: "badge badge-warning",
    2: "badge badge-secondary",
    3: "badge badge-info",
    4: "badge badge-danger",
    5: "badge badge-success",
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const editFormatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredDataSource = dataSource?.filter((item) => {
    return (
      (item.IndentNo &&
        item.IndentNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.StoreName &&
        item.StoreName.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  });

  const printIndent = (indentNo) => {
    if (!userDataSession?.OrgId || !indentNo) return;

    Axios.get(
      `${API_BASE_URL}${GET_STOCK_INDENT_LIST}?OrgId=${userDataSession.OrgId}&IndentNo=${indentNo}`,
    )
      .then((response) => {
        if (response.data.Status) {
          setIndentPrintData(response.data.ResultData);
          setIsPrintTriggered(true);
        } else {
          console.error("Error fetching data:", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("Error fetching print data:", error);
      });
  };

  // ✅ NEW — Print effect. Same pattern used for Stock Transfer: only fires
  // once indentPrintData has actually updated (avoids the stale/blank-print
  // race a setTimeout would have), opens the native print preview, and
  // closes the popup once the dialog is dismissed.
  useEffect(() => {
    if (!isPrintTriggered || !indentPrintData?.length) {
      return;
    }

    const printContents = printRef.current?.innerHTML;

    if (!printContents) {
      console.error("Print content not found");
      setIsPrintTriggered(false);
      return;
    }

    const printWindow = window.open("", "_blank");

    if (!printWindow) {
      console.error("Unable to open print window");
      setIsPrintTriggered(false);
      return;
    }

    printWindow.document.write(`
      <html>
        <head>
          <title>Print Indent</title>
          <style>
            * { box-sizing: border-box; }

            @page {
              size: A4;
              margin: 0;
            }

            body {
              font-family: 'Segoe UI', Arial, sans-serif;
              margin: 0;
              padding: 0;
              color: #33404f;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            th, td {
              font-size: 10.5px;
            }

            /* Padding lives on #print-wrapper (0.5in, box-sizing:border-box)
               so print and any future download path render identically. */
            #print-wrapper {
              display: flex;
              flex-direction: column;
              min-height: 100vh;
              padding: 0.5in;
              box-sizing: border-box;
            }

            #print-footer {
              margin-top: auto;
              padding-top: 8px;
              border-top: 1px solid #1f3a5f;
              text-align: center;
            }

            @media print {
              body { margin: 0; }
            }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);

    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    };

    printWindow.onafterprint = () => {
      printWindow.close();
    };

    setIsPrintTriggered(false);
  }, [indentPrintData, isPrintTriggered]);

  // #region Assigning Data to Table
  const columns = [
    {
      title: "Number",
      dataIndex: "IndentNo",
      sorter: (a, b) => {
        const aValue = a.IndentNo || "";
        const bValue = b.IndentNo || "";
        return aValue.localeCompare(bValue);
      },
    },
    {
      title: "Project",
      dataIndex: "Project",
    },
    {
      title: "Date",
      dataIndex: "IndentDt",
      sorter: (a, b) => new Date(a.IndentDt) - new Date(b.IndentDt),
      render: (text) => formatDate(text),
    },
    {
      title: "Products",
      dataIndex: "ProductCount",
      render: (record) => (record ? record : "0"),
    },
    {
      title: "Store",
      dataIndex: "StoreName",
      sorter: (a, b) => a.StoreName.localeCompare(b.StoreName),
    },

    {
      title: "Status",
      dataIndex: "IndentStatus",
      sorter: (a, b) => a.IndentStatus - b.IndentStatus,
      render: (status) => (
        <span className={statusClassNames[status]}>{statusOrder[status]}</span>
      ),
    },
    ...(canViewRateAndTotal
      ? [
          {
            title: "Total",
            dataIndex: "OverallTotal",
            render: (value) =>
              value !== null && value !== undefined
                ? `₹${Number(value).toFixed(2)}`
                : "-",
          },
        ]
      : []),
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <td>
          <div className="edit-delete-action">
            <Link
              to="#"
              className="dropdown-oggle nav-lik selet-store"
              data-bs-toggle="dropdown"
            >
              <i className="fa-solid fa-ellipsis-vertical btn border"></i>
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link
                to="#"
                className={`dropdown-item ms-3 mb-3 mt-2 ${permissions.isRead}`}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightIndView"
                aria-controls="offcanvasRightIndView"
                onClick={() => showViewModal(record)}
              >
                <i className="fa-regular fa-eye me-2"></i>
                View
              </Link>

              {canViewRateAndTotal && (
                <Link
                  to="#"
                  className="dropdown-item ms-3 mb-3 mt-2"
                  onClick={() => printIndent(record.IndentNo)}
                >
                  <i className="fa-solid fa-print me-2"></i>
                  Print
                </Link>
              )}

              <Link
                to="#"
                className={`dropdown-item ms-3 mb-3 mt-3  ${
                  record.IndentStatus == 1 ? "" : "disabled"
                }`}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightIndEdit"
                aria-controls="offcanvasRightIndEdit"
                onClick={() => showEditModal(record)}
              >
                <i className="fa-regular fa-pen-to-square me-2"></i>
                Edit
              </Link>
              <Link
                to="#"
                className={`dropdown-item ms-3 mb-3 mt-2 ${userDataSession.RoleId === 3 && record.IndentStatus === 1 ? "" : "disabled"}`}
                onClick={() => showConfirmationAlert(record)}
              >
                <i className="fa-regular fa-trash-can me-2"></i>
                Delete
              </Link>
            </div>
          </div>
        </td>
      ),
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this indent?",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteIndent(record.IndentNo);
      } else {
        MySwal.close();
      }
    });
  };

  const deleteIndent = (recordId) => {
    const deleteData = {
      UserId: userDataSession.UserId,
      IndentNo: recordId,
    };

    Axios.post(`${API_BASE_URL}${DELETE_INDENT}`, deleteData)
      .then((response) => {
        if (response.data.ResultData[0].Status === "Success") {
          MySwal.fire({
            title: "Deleted!",
            text: "The indent has been deleted.",
            icon: "success",
          }).then(() => {
            fetchStockIndentList();
          });
        } else {
          MySwal.fire({
            title: "Failed!",
            text: response.data.Message || "Failed to delete the indent.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error deleting indent:", error);
        MySwal.fire({
          title: "Error!",
          text: "An error occurred while deleting the indent.",
          icon: "error",
        });
      });
  };

  const handleStoreSelectChange = (selectedOption) => {
    setSelectedStore(selectedOption);
    setExcelErrorMess("");
  };

  const fileInputRef = useRef(null);

  const handleClearDisplay = () => {
    setSelectedProduct(null);
    setIsDisplayExcel(false);
    setIsDisplayProduct(true);
    setSelectedDate(today);
    setSelectedProducts([]);
    setSelectedFile(null);
    setIsDisplayProductBtn(true);
    setIsDisplayExcelBtn(false);
    setErrorMessage("");
    setProject("");
    setNotes("");
    setLocation("");
    setSelectedProjectOption(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    if (storeData.length === 1) {
      const selectedStoreObj = {
        value: storeData[0].StoreId,
        label: storeData[0].Name,
      };
      setSelectedStore(selectedStoreObj);
      setSelctedFilterStore(selectedStoreObj);
    }
  };

  const handleProductSelectChange = (value) => {
    setErrorMessage(`Excel upload is disabled because products have already been selected.<br/>
     Please clear the selected products to enable Excel upload.`);

    setSelectedProduct(value);
    setIsDisplayExcel(true);
    setIsDisplayExcelBtn(false);
    setIsDisplayProductBtn(true);

    const isProductSelected = selectedProducts.some(
      (product) => product.id === value.value,
    );

    if (isProductSelected) {
      alert("Product already selected!");
      return;
    }

    const selectedProductData = productsData.find(
      (product) => product.Id === value.value,
    );

    const storePrice = Number(selectedProductData?.StorePrice || 0);

    const product = {
      id: value.value,
      name: value.label,
      quantity: "",
      price: storePrice,
      total: 0,
    };

    setSelectedProducts([...selectedProducts, product]);
  };

  const handleQuantityChange = (value, index) => {
    const updatedProducts = [...selectedProducts];

    const quantity = Number(value) || 0;
    const price = Number(updatedProducts[index].price) || 0;

    updatedProducts[index].quantity = value;
    updatedProducts[index].total = quantity * price;

    setSelectedProducts(updatedProducts);
  };

  const handlePriceChange = (value, index) => {
    const updatedProducts = [...selectedProducts];

    const price = Number(value) || 0;
    const quantity = Number(updatedProducts[index].quantity) || 0;

    updatedProducts[index].price = value;
    updatedProducts[index].total = quantity * price;

    setSelectedProducts(updatedProducts);
  };

  const overallTotal = selectedProducts.reduce(
    (sum, product) => sum + (Number(product.total) || 0),
    0,
  );
  const handleDelete = (index, event) => {
    event.preventDefault();
    setSelectedProducts((prevData) => prevData.filter((_, i) => i !== index));
  };

  // #region handlesubmit Add
  const handleSubmit = (operation) => async (e) => {
    e.preventDefault();
    if (!selectedStore) {
      alert("Please select a store.");
      return;
    }

    const payload = {
      StoreName: `${selectedStore.label}`,
      StockIndent: [
        {
          OrgId: userDataSession.OrgId,
          StoreId: selectedStore?.value,
          IndentDt: `${selectedDate}`,
          Operation: `${operation}`,
          UserId: userDataSession.UserId,
          IndentNo: 0,
          IndentType: "Insert",
          Project: project,
          Notes: notes,
          Location: location,
        },
      ],
      ProductDetails: selectedProducts?.map((product) => ({
        IndentId: 0,
        ProductId: product.id,
        Quantity: `${product.quantity}`,
        Price: Number(product.price) || 0,
        Total: Number(product.total) || 0,
      })),
    };

    console.log(payload, "data sending to service...");

    try {
      setSubmitBtnLoading(true);
      const response = await Axios.post(
        `${API_BASE_URL}${INSERT_STOCK_INDENT}`,
        payload,
      );
      const data = response.data;

      if (data[0]["Success"] === 1) {
        setSubmitBtnLoading(false);
        Swal.fire({
          title: `Indent Added Successfully.`,
          icon: "success",
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            window.location.reload();
          }
        });
      } else {
        setSubmitBtnLoading(false);
        Swal.fire({
          title: "Error",
          text: "Failed to Request Submit.",
          icon: "error",
        });
      }
    } catch (error) {
      setSubmitBtnLoading(false);
      console.error("Error:", error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
      });
    }
  };

  const showEditModal = (dataObj) => {
    const requestData = {
      OrgId: userDataSession.OrgId,
      CategoryId: 0,
      BarCode: "0",
      IsActive: 1,
      ProductId: 0,
      StoreId: dataObj.StoreId,
      IsForSale: 1,
      UserId: userDataSession.UserId,
      Type: 1,
    };

    if (userDataSession && userDataSession.OrgId && dataObj.StoreId) {
      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            setProductsData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }

    if (dataObj.IndentNo) {
      const fetchData = () => {
        Axios.get(
          `${API_BASE_URL}${GET_STOCK_INDENT_LIST}?OrgId=${userDataSession.OrgId}&IndentNo=${dataObj.IndentNo}`,
        )
          .then((response) => {
            if (response.data.Status) {
              const updatedProducts = response.data.ResultData.map(
                (product) => {
                  const storeProduct = productsData.find(
                    (prod) => prod.Id === product.ProductId,
                  );

                  const price =
                    product.Price !== null &&
                    product.Price !== undefined &&
                    product.Price !== ""
                      ? Number(product.Price)
                      : Number(storeProduct?.StorePrice || 0);

                  const quantity = Number(product.ReqQty) || 0;

                  return {
                    ...product,
                    Price: price,
                    Total:
                      product.Total !== null &&
                      product.Total !== undefined &&
                      product.Total !== ""
                        ? Number(product.Total)
                        : price * quantity,
                  };
                },
              );

              setIndentProducts(updatedProducts);
            } else {
              console.error("Error fetching data:", response.data.Message);
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      };
      fetchData();
    }
    setEditObj(dataObj);
    setEditProject(dataObj.Project || "");
    setEditNotes(dataObj.Notes || "");
  };

  const showViewModal = (dataObj) => {
    setViewObj(dataObj);
  };
  const editOverallTotal = indentProducts.reduce(
    (sum, product) => sum + (Number(product.Total) || 0),
    0,
  );
  const handleEditProductSelectChange = (e) => {
    const selectedProductId = parseInt(e.target.value);
    const selectedProduct = productsData.find(
      (prod) => prod.Id === selectedProductId,
    );

    const productExists = indentProducts.some(
      (prod) => prod.ProductId === selectedProductId,
    );

    if (selectedProduct && !productExists) {
      setIndentProducts((prevIndentProducts) => {
        const updatedProducts = [
          ...prevIndentProducts,
          {
            ProductId: selectedProduct.Id,
            ProductName: selectedProduct.ProductName,
            IndentId: 0,
            ReqQty: 0,
            Price: Number(selectedProduct.StorePrice || 0),
            Total: 0,
          },
        ];
        return updatedProducts;
      });
    }
  };

  const handleEditQuantityChange = (value, index) => {
    const updatedProducts = [...indentProducts];

    const quantity = Number(value) || 0;
    const price = Number(updatedProducts[index].Price) || 0;

    updatedProducts[index].ReqQty = value;
    updatedProducts[index].Total = quantity * price;

    setIndentProducts(updatedProducts);
  };

  const handleEditPriceChange = (value, index) => {
    const updatedProducts = [...indentProducts];

    const price = Number(value) || 0;
    const quantity = Number(updatedProducts[index].ReqQty) || 0;

    updatedProducts[index].Price = value;
    updatedProducts[index].Total = quantity * price;

    setIndentProducts(updatedProducts);
  };

  const handleRemoveProduct = (productId) => {
    const updatedProducts = indentProducts.filter(
      (item) => item.ProductId !== productId,
    );
    setIndentProducts(updatedProducts);
  };

  // #region handle edit submit
  const handleEditSubmit = (operation) => async (e) => {
    e.preventDefault();

    const requestData = {
      StockIndent: [
        {
          OrgId: userDataSession.OrgId,
          StoreId: editObj.StoreId,
          IndentDt: `${editFormatDate(editObj.IndentDt)}`,
          Operation: `${operation}`,
          UserId: userDataSession.UserId,
          IndentNo: `${editObj.IndentNo}`,
          Project: editProject,
          Notes: editNotes,
          Location: editLocation,
        },
      ],
      ProductDetails: indentProducts?.map((product) => ({
        IndentId: product.IndentId ? product.IndentId : 0,
        ProductId: product.ProductId,
        Quantity: `${product.ReqQty}`,
        Price: Number(product.Price) || 0,
        Total: Number(product.Total) || 0,
      })),
      Type: "Update",
    };
    if (operation == "Submit") {
      setEditSubmitLoading(true);
    } else {
      setDraftEditBtnLoading(true);
    }

    Axios.post(`${API_BASE_URL}${INSERT_STOCK_INDENT}`, requestData)
      .then((response) => {
        if (response.data[0].Success === 1) {
          setEditSubmitLoading(false);
          setDraftEditBtnLoading(false);
          Swal.fire({
            title: `Stock Indent Updated Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          setEditSubmitLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to update Stock Indent.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setEditSubmitLoading(false);
        setDraftEditBtnLoading(false);
        console.error("Error:", error);
        Swal.fire({
          title: "Error",
          text: "Failed to update Stock Indent.",
          icon: "error",
        });
      });
  };

  const handleDownloadExcel = () => {
    if (data.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();

    const mapStatus = (status) => {
      switch (status) {
        case 1:
          return "Draft";
        case 2:
          return "Sent";
        case 3:
          return "Approved";
        case 4:
          return "Reject";
        default:
          return "N/A";
      }
    };

    const wsData = dataSource.map((item) => ({
      "Indent Number": item.IndentNo,
      Date: formatDate(item.IndentDt),
      StoreName: item.StoreName,
      Status: mapStatus(item.IndentStatus),
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    XLSX.utils.book_append_sheet(wb, ws, "IndentData");

    XLSX.writeFile(wb, "IndentData.xlsx");
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    doc.setProperties({
      title: "Attendance Report",
      author: "Your Name",
      creator: "Your Application",
    });

    const mapStatus = (status) => {
      switch (status) {
        case 1:
          return "Draft";
        case 2:
          return "Sent";
        case 3:
          return "Approved";
        case 4:
          return "Reject";
        default:
          return "N/A";
      }
    };

    const tableData = [];

    const headers = ["Number", "Date", "StoreName", "Status"];
    tableData.push(headers);

    dataSource.forEach((item) => {
      const row = [];
      row.push(
        item.IndentNo,
        formatDate(item.IndentDt),
        item.StoreName,
        mapStatus(item.IndentStatus),
      );
      tableData.push(row);
    });

    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    doc.save("IndentData.pdf");
  };

  // region Excel Downlaod
  const handleAddDownloadExcel = (e) => {
    e.preventDefault();

    if (!selectedStore) {
      setExcelErrorMess("Please Select Store...");
    } else {
      const link = document.createElement("a");
      link.href = `${API_BASE_URL}${DOWNLD_EXCEL}?StoreId=${selectedStore.value}&OrgId=${userDataSession.OrgId}`;

      link.download = "Products.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleFileChange = (event) => {
    setSelectedProduct(null);
    setIsDisplayProduct(false);
    setIsDisplayProductBtn(false);
    setIsDisplayExcelBtn(true);
    setErrorMessage(`Product selection is disabled because an Excel file has already been uploaded.
      <br/> Please clear the uploaded file to enable product selection.`);

    const file = event.target.files[0];
    if (
      file &&
      (file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel")
    ) {
      setSelectedFile(file);
    } else {
      setIsDisplayProduct(true);
      alert("Please select a valid Excel file.");
    }
  };

  // #region Handle file upload
  const handleUploadExcel = (operation) => async (e) => {
    e.preventDefault();

    if (!selectedStore) {
      alert("Please select a store.");
      return;
    }

    if (!selectedFile) {
      alert("Please choose a file.");
      return;
    }

    const formData = new FormData();
    formData.append("OrgId", userDataSession.OrgId);
    formData.append("StoreId", `${selectedStore.value}`);
    formData.append("IndentDt", `${selectedDate}`);
    formData.append("Operation", `${operation}`);
    formData.append("UserId", userDataSession.UserId);
    formData.append("IndentType", "Insert");
    formData.append("IndentNo", "0");
    formData.append("file", selectedFile);

    try {
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const response = await fetch(`${API_BASE_URL}${UPLOAD_EXCEL}`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        alert("File uploaded successfully");
        window.location.reload();
      } else {
        alert(
          "The uploaded file format is invalid. Please upload a valid Excel file.",
        );
        console.error("Upload failed", response.statusText);
      }
    } catch (error) {
      console.error("Error uploading file", error);
      alert("Error uploading file");
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "2.4rem",
      height: "2.4rem",
      padding: "0 8px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "2.4rem",
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
    }),
    placeholder: (provided) => ({
      ...provided,
      margin: 0,
      position: "absolute",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: 0,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 10000,
    }),
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setOffcanvasWidth("85%");
      } else {
        setOffcanvasWidth("50%");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const handleClose = () => {
    setSelectedProduct(null);
    setSelectedDate(today);
    setSelectedProducts([]);
    setIsDisplayExcelBtn(false);
    setIsDisplayProductBtn(true);
    setErrorMessage("");
    setLocation("");

    if (storeData.length === 1) {
      const selectedStoreObj = {
        value: storeData[0].StoreId,
        label: storeData[0].Name,
      };
      setSelectedStore(selectedStoreObj);
      setSelctedFilterStore(selectedStoreObj);
    }
  };

  // ✅ NEW — derived print values. OverallTotal already comes correct per
  // line from GET_STOCK_INDENT_LIST (window function fix), so this just
  // reads the first row; the reduce() is a safety net only.
  const printOverallTotal =
    indentPrintData?.[0]?.OverallTotal ??
    indentPrintData.reduce((sum, item) => sum + (Number(item.Total) || 0), 0);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Indent list</h4>
                <h6>Manage your Indents</h6>
              </div>
            </div>
            <ul className="table-top-head mt-3 mt-md-0">
              <li onClick={generatePDF}>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleDownloadExcel}>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <div className={`page-btn `}>
                  <Link
                    to="#"
                    className="btn btn-added d-flex ms-auto"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRightIndAdd"
                    aria-controls="offcanvasRightIndAdd"
                  >
                    <PlusCircle className="me-2" />
                    Add Indent
                  </Link>
                </div>
              </li>
            </ul>
          </div>
          {/* /indent list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="input-group search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                    <span className="input-group-text bg-white">
                      <i data-feather="search" className="feather-search"></i>
                    </span>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                  >
                    <Filter
                      className="filter-icon"
                      onClick={toggleFilterVisibility}
                    />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
              </div>
              {/* /Filter */}
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row mb-2">
                    <div className="col-lg-3 col-sm-6 col-12">
                      <label>Store</label>
                      <Select
                        className="select"
                        options={[
                          { value: 0, label: "All" },
                          ...(storeData
                            ? storeData.map((store) => ({
                                value: store.StoreId,
                                label: store.Name,
                              }))
                            : []),
                        ]}
                        placeholder="Choose store"
                        onChange={handleStoreFilterChange}
                        value={selectedFilterStore || null}
                        styles={customStyles}
                      />
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <label>Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={selectedFilterDate}
                        onChange={handleFilterDateChange}
                      />
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                      <label>Status</label>
                      <Select
                        className="select"
                        options={indStatusOptions}
                        placeholder="Choose status"
                        onChange={handleStatusFilterChange}
                        value={selectedFilterStatus || null}
                        styles={customStyles}
                      />
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                      <div className="input-blocks">
                        <button
                          className="btn btn-filters ms-auto"
                          onClick={fetchFilterData}
                        >
                          <i data-feather="search" className="feather-search" />
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Filter */}
              <div className="table-responsive">
                {loading ? (
                  <div className="loader m-auto"></div>
                ) : (
                  <Table
                    columns={columns}
                    dataSource={filteredDataSource}
                    locale={{
                      emptyText: "No data available",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          {/* /indent list */}
        </div>
      </div>

      {/* Add */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightIndAdd"
        aria-labelledby="offcanvasRightLabel"
        style={{ maxWidth: offcanvasWidth }}
      >
        <div className="offcanvas-header mt-1" style={{ height: "25px" }}>
          <h4 id="offcanvasRightLabel">Add Indent</h4>
          <p className="text-danger fw-semibold">{excelErrorMess}</p>
          <div className="d-flex ms-auto align-items-center">
            <div className="d-flex justify-content-end align-items-center">
              <p className="mb-0">Download Template</p>
              <button
                className="btn d-flex"
                title="Download template"
                onClick={handleAddDownloadExcel}
              >
                <i className="fa-solid fa-download text-danger fs-4"></i>
              </button>
            </div>
            <button
              type="button"
              className="btn-close text-reset ms-2"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={handleClose}
            />
          </div>
        </div>{" "}
        <hr />
        <div className="offcanvas-body" style={{ marginTop: "-22px" }}>
          {addBtnStatus === "No" && userDataSession.RoleId === 3 && (
            <div className="alert alert-warning">
              You are submitting the indent outside the allowed days.
              <br />
              Alternatively, you can
              <span
                className="fw-bold text-info text-decoration-underline"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightLateIndentReq"
                aria-controls="offcanvasRightLateIndentReq"
                style={{ cursor: "pointer" }}
              >
                {" "}
                click here
              </span>{" "}
              to send a request for indent addition.
            </div>
          )}

          <div
            className={`alert alert-warning ${errorMessage.length > 1 ? "d-block" : "d-none"}`}
            dangerouslySetInnerHTML={{ __html: errorMessage }}
          ></div>

          <form>
            <div className="row mb-2">
              <div className="col-lg-6 col-md-6 mb-3">
                <label className="form-label">
                  Store<span className="fw-bold text-danger">*</span>
                </label>
                <Select
                  className="select"
                  options={
                    storeData &&
                    storeData?.map((store) => ({
                      value: store.StoreId,
                      label: store.Name,
                    }))
                  }
                  placeholder="Choose store"
                  value={selectedStore || ""}
                  onChange={handleStoreSelectChange}
                  styles={customStyles}
                />
              </div>
              <div className="col-lg-6 col-md-6 mb-1">
                <label className="form-label">
                  Date<span className="fw-bold text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="SubCategoryName"
                  name="Date"
                  value={selectedDate}
                  onChange={handleDateChange}
                />
              </div>

              <div className="col-lg-6">
                <label className="form-label">By Excel</label>
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  className="form-control mb-3"
                  style={{ width: "100%", height: "2.5rem" }}
                  onChange={handleFileChange}
                  disabled={isDisplayExcel}
                  ref={fileInputRef}
                />
              </div>
              <div className="col-lg-6 col-md-6 mb-3">
                <label className="form-label">Project</label>
                <CreatableSelect
                  className="select"
                  options={projectOptions}
                  placeholder="Type or select project"
                  value={selectedProjectOption}
                  onChange={(selected) => {
                    setSelectedProjectOption(selected);
                    setProject(selected ? selected.value : "");
                  }}
                  isClearable
                  isSearchable
                  styles={customStyles}
                />
              </div>
              <div className="col-lg-6 col-md-6 mb-3">
                <label className="form-label">Location</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Location"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                />
              </div>

              <div className="col-lg-6 col-md-12 mb-3">
                <label className="form-label">Indent For</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Indent For"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>
              <div className="row justify-content-end mt-3"></div>

              <div className="col-8 mb-3">
                <label className="form-label">By Product</label>
                <Select
                  className="select"
                  options={
                    productsData && productsData.length > 0
                      ? productsData?.map((prod) => ({
                          value: prod.Id,
                          label: prod.ProductName,
                        }))
                      : []
                  }
                  placeholder="Choose product"
                  onChange={handleProductSelectChange}
                  styles={customStyles}
                  isDisabled={!isDisplayProduct}
                  value={selectedProduct}
                />
              </div>
              <div className="col-lg-4 col-md-6 d-none">
                <label className="form-label">Total</label>
                <input
                  type="text"
                  className="form-control"
                  value={overallTotal.toFixed(2)}
                  readOnly
                />
              </div>

              <div
                className="col-12 table-responsive mt-2"
                style={{ overflowY: "auto", maxHeight: "250px" }}
              >
                <table className="table datanew">
                  <thead className="sticky-top">
                    <tr>
                      <th>#</th>
                      <th>Product</th>

                      <th>Qty</th>
                      {canViewRateAndTotal && <th>Rate</th>}
                      {canViewRateAndTotal && <th>Total</th>}
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {selectedProducts?.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>

                        <td
                          title={product.name}
                          style={{
                            maxWidth: "220px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {canViewRateAndTotal
                            ? truncateText(product.name, 25)
                            : product.name}
                        </td>

                        <td>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter quantity"
                            value={product.quantity}
                            onChange={(e) =>
                              handleQuantityChange(e.target.value, index)
                            }
                            style={{ width: "7rem" }}
                            min="0"
                            onWheel={(e) => e.target.blur()}
                          />
                        </td>
                        {canViewRateAndTotal && (
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={product.price}
                              onChange={(e) =>
                                handlePriceChange(e.target.value, index)
                              }
                              style={{ width: "7rem" }}
                              min="0"
                              step="0.01"
                              onWheel={(e) => e.target.blur()}
                            />
                          </td>
                        )}
                        {canViewRateAndTotal && (
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={product.total || 0}
                              readOnly
                              style={{
                                width: "8rem",
                                backgroundColor: "#f5f5f5",
                              }}
                            />
                          </td>
                        )}
                        <td>
                          <button
                            type="button"
                            className="btn border text-danger"
                            onClick={(e) => handleDelete(index, e)}
                          >
                            <i className="feather-trash-2 fs-6"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="modal-footer-btn d-flex justify-content-end sticky-bottom">
              <button
                type="button"
                className="btn btn-danger me-2"
                onClick={handleClearDisplay}
                disabled={submitBtnLoading}
              >
                Clear
              </button>

              <button
                type="submit"
                className={`btn btn-primary me-2 ${isDisplayProductBtn ? "d-block" : "d-none"}`}
                onClick={handleSubmit("DRAFT")}
                disabled={submitBtnLoading}
              >
                {submitBtnLoading ? "Saving..." : "Save as Draft"}
              </button>
              <button
                type="submit"
                className={`btn btn-success ${isDisplayProductBtn ? "d-block" : "d-none"}
                  ${addBtnStatus === "Yes" ? "d-block" : "d-none"}
                `}
                onClick={handleSubmit("SENT")}
                disabled={submitBtnLoading}
              >
                {submitBtnLoading ? "Submitting..." : "Submit"}
              </button>

              <button
                type="submit"
                className={`btn btn-primary me-2 ${isDisplayExcelBtn ? "d-block" : "d-none"}`}
                onClick={handleUploadExcel("DRAFT")}
                disabled={submitBtnLoading}
              >
                {submitBtnLoading ? "Saving..." : "Save as Draft"}
              </button>
              <button
                type="submit"
                className={`btn btn-success ${isDisplayExcelBtn ? "d-block" : "d-none"}
                ${addBtnStatus === "Yes" ? "d-block" : "d-none"}
                `}
                onClick={handleUploadExcel("SENT")}
                disabled={submitBtnLoading}
              >
                {submitBtnLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Edit */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightIndEdit"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "300px", maxWidth: "48%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Edit Indent</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          <p className="fw-semibold">{editObj.IndentNo}</p>
          <form>
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3">
                <label className="form-label">Store</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Store Name"
                  value={editObj.StoreName}
                  style={{ cursor: "not-allowed" }}
                  readOnly
                />
              </div>
              <div className="col-lg-6 col-md-6 mb-1">
                <label className="form-label">Date</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Date"
                  value={formatDate(editObj.IndentDt)}
                  style={{ cursor: "not-allowed" }}
                  readOnly
                />
              </div>
              <div className="col-lg-6 col-md-6 mb-3">
                <label className="form-label">Project</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Project"
                  value={editProject}
                  onChange={(e) => setEditProject(e.target.value)}
                />
              </div>

              <div className="col-lg-6 col-md-6 mb-3">
                <label className="form-label">Location</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Location"
                  value={editLocation}
                  onChange={(e) => setEditLocation(e.target.value)}
                />
              </div>

              <div className="col-lg-6 col-md-12 mb-3">
                <label className="form-label">Indent For</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Indent For"
                  value={editNotes}
                  onChange={(e) => setEditNotes(e.target.value)}
                />
              </div>
              <div className="row justify-content-end mt-3 d-none">
                <div className="col-lg-4 col-md-6">
                  <label className="form-label"> Total Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editOverallTotal.toFixed(2)}
                    readOnly
                  />
                </div>
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">Product</label>
                <select
                  className="form-select"
                  onChange={handleEditProductSelectChange}
                >
                  <option value="">Select a product</option>
                  {productsData?.map((item, index) => (
                    <option key={index} value={item.Id}>
                      {item.ProductName}
                    </option>
                  ))}
                </select>
              </div>
              <br />
              <div
                className="col-12 table-responsive mt-2"
                style={{ maxHeight: "20rem", overflowY: "auto" }}
              >
                <table className="table datanew">
                  <thead className="sticky-top">
                    <tr>
                      <th>#</th>
                      <th>Product</th>
                      <th>Qty</th>
                      {canViewRateAndTotal && <th>Rate</th>}
                      {canViewRateAndTotal && <th>Total</th>}

                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {indentProducts &&
                      indentProducts.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>

                          <td
                            title={item.ProductName}
                            style={{
                              maxWidth: "220px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {truncateText(item.ProductName, 20)}
                          </td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter quantity"
                              value={item.ReqQty}
                              style={{ width: "7rem" }}
                              min="0"
                              onChange={(e) =>
                                handleEditQuantityChange(e.target.value, index)
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </td>

                          {canViewRateAndTotal && (
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                value={item.Price ?? 0}
                                style={{ width: "7rem" }}
                                min="0"
                                step="0.01"
                                onChange={(e) =>
                                  handleEditPriceChange(e.target.value, index)
                                }
                                onWheel={(e) => e.target.blur()}
                              />
                            </td>
                          )}
                          {canViewRateAndTotal && (
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={item.Total ?? 0}
                                readOnly
                                style={{
                                  width: "8rem",
                                  backgroundColor: "#f5f5f5",
                                }}
                              />
                            </td>
                          )}
                          <td>
                            <button
                              type="button"
                              className="btn border text-danger"
                              onClick={() =>
                                handleRemoveProduct(item.ProductId)
                              }
                            >
                              <i className="feather-trash-2 fs-6"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="modal-footer-btn d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`btn btn-primary me-2`}
                onClick={handleEditSubmit("DRAFT")}
                disabled={draftEditBtnLoading}
              >
                {draftEditBtnLoading ? "Saving..." : "Save as Draft"}
              </button>
              <button
                type="submit"
                className={`btn btn-success ${
                  addBtnStatus === "Yes" ? "d-block" : "d-none"
                }`}
                onClick={handleEditSubmit("SENT")}
                disabled={editSubmitLoading}
              >
                {editSubmitLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <ViewIndent IndentObj={viewObj} />
      <ApplyLateIndentReq />

      {/* Print Template */}
      <div
        ref={printRef}
        className="pdf-document"
        style={{
          position: "absolute",
          top: 0,
          left: "-10000px",
          width: "794px",
          fontFamily: "'Segoe UI', Arial, sans-serif",
          color: "#33404f",
          background: "#ffffff",
        }}
      >
        <div
          id="print-wrapper"
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "1050px",
            padding: "0.5in",
            boxSizing: "border-box",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              borderBottom: "3px solid #1f3a5f",
              paddingBottom: "8px",
              marginBottom: "16px",
            }}
          >
            <div style={{ flex: 1 }}>
              <h4
                style={{
                  margin: "2px 0 0 0",
                  color: "#1f3a5f",
                  fontWeight: 700,
                }}
              >
                {indentPrintData?.[0]?.IndentNo || ""}
              </h4>
            </div>

            <div style={{ flex: 1, textAlign: "center" }}>
              <h4
                style={{
                  margin: 0,
                  color: "#1f3a5f",
                  fontWeight: 700,
                  letterSpacing: "0.5px",
                }}
              >
                Indent Detail Report
              </h4>
            </div>

            <div style={{ flex: 1, textAlign: "right" }}>
              <p
                style={{
                  margin: 0,
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#33404f",
                }}
              >
                Date -{" "}
                {indentPrintData?.[0]?.IndentDt
                  ? formatDate(indentPrintData[0].IndentDt)
                  : ""}
              </p>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "16px",
              marginBottom: "18px",
            }}
          >
            <div
              style={{
                width: "48%",
                border: "1px solid #d7dce3",
                borderRadius: "4px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  backgroundColor: "#1f3a5f",
                  color: "#ffffff",
                  fontSize: "10px",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  padding: "5px 10px",
                }}
              >
                Store
              </div>
              <div
                style={{
                  padding: "8px 10px",
                  fontSize: "10px",
                  lineHeight: "1.6",
                }}
              >
                <p style={{ margin: 0, fontWeight: 600, color: "#1f3a5f" }}>
                  {indentPrintData?.[0]?.StoreName || ""}
                </p>
                <p style={{ margin: 0 }}>
                  {indentPrintData?.[0]?.StoreAddress || ""}
                </p>
                <p>
                  <strong>Contact:</strong>{" "}
                  {indentPrintData?.[0]?.StoreContact || "-"}
                </p>
              </div>
            </div>

            <div
              style={{
                width: "48%",
                border: "1px solid #d7dce3",
                borderRadius: "4px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  backgroundColor: "#1f3a5f",
                  color: "#ffffff",
                  fontSize: "10px",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  padding: "5px 10px",
                }}
              >
                Details
              </div>
              <div
                style={{
                  padding: "8px 10px",
                  fontSize: "10px",
                  lineHeight: "1.6",
                }}
              >
                <p style={{ margin: 0 }}>
                  <strong>Project:</strong>{" "}
                  {indentPrintData?.[0]?.Project || "-"}
                </p>
                <p style={{ margin: 0 }}>
                  <strong>Location:</strong>{" "}
                  {indentPrintData?.[0]?.Location || "-"}
                </p>
                <p style={{ margin: 0 }}>
                  <strong>Indent For:</strong>{" "}
                  {indentPrintData?.[0]?.Notes || "-"}
                </p>
              </div>
            </div>
          </div>

          {/* Items table */}
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "14px",
            }}
          >
            <thead>
              <tr>
                {["#", "Product", "Qty", "Price", "Total"].map((h, i) => (
                  <th
                    key={i}
                    style={{
                      border: "1px solid #1f3a5f",
                      padding: "6px 8px",
                      textAlign: i >= 2 ? "right" : "left",
                      backgroundColor: "#1f3a5f",
                      color: "#ffffff",
                      fontSize: "10.5px",
                      fontWeight: 600,
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {indentPrintData?.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f7fa",
                  }}
                >
                  <td
                    style={{
                      border: "1px solid #d7dce3",
                      padding: "5px 8px",
                      fontSize: "10px",
                      color: "#1f3a5f",
                    }}
                  >
                    {index + 1}
                  </td>
                  <td
                    style={{
                      border: "1px solid #d7dce3",
                      padding: "5px 8px",
                      fontSize: "10px",
                      color: "#1f3a5f",
                    }}
                  >
                    {item.ProductName}
                  </td>
                  <td
                    style={{
                      border: "1px solid #d7dce3",
                      padding: "5px 8px",
                      fontSize: "10px",
                      textAlign: "right",
                      color: "#1f3a5f",
                    }}
                  >
                    {item.ReqQty}
                  </td>
                  <td
                    style={{
                      border: "1px solid #d7dce3",
                      padding: "5px 8px",
                      fontSize: "10px",
                      textAlign: "right",
                      color: "#1f3a5f",
                    }}
                  >
                    {formatIndianCurrency(item.Price)}
                    {/* {Number(item.Price || 0).toFixed(2)} */}
                  </td>
                  <td
                    style={{
                      border: "1px solid #d7dce3",
                      padding: "5px 8px",
                      fontSize: "10px",
                      textAlign: "right",
                      color: "#1f3a5f",
                    }}
                  >
                    {formatIndianCurrency(item.Total || 0)}
                  </td>
                </tr>
              ))}
              <tr>
                <td
                  colSpan="4"
                  style={{
                    border: "1px solid #1f3a5f",
                    padding: "6px 8px",
                    fontWeight: 700,
                    textAlign: "right",
                    backgroundColor: "#eef1f5",
                    fontSize: "10.5px",
                    color: "#1f3a5f",
                  }}
                >
                  Overall Total:
                </td>
                <td
                  style={{
                    border: "1px solid #1f3a5f",
                    padding: "6px 8px",
                    fontWeight: 700,
                    textAlign: "right",
                    backgroundColor: "#eef1f5",
                    fontSize: "10.5px",
                  }}
                >
                  {formatIndianCurrency(printOverallTotal || 0)}
                </td>
              </tr>
            </tbody>
          </table>

          <div
            style={{
              borderLeft: "3px solid #1f3a5f",
              backgroundColor: "#fafbfc",
              padding: "8px 12px",
              marginBottom: "16px",
            }}
          >
            <p
              style={{
                margin: "0 0 4px 0",
                fontSize: "9.5px",
                fontWeight: 700,
                color: "#1f3a5f",
              }}
            >
              Comments / Special Instructions
            </p>
            <p
              style={{ margin: "0 0 2px 0", fontSize: "9px", color: "#4a5568" }}
            >
              • Please verify the quantities and rates before approval.
            </p>
            <p
              style={{
                margin: 0,
                fontSize: "9.5px",
                fontWeight: 600,
                textAlign: "center",
                color: "#1f3a5f",
              }}
            >
              Thank you for your business.
            </p>
          </div>

          <div id="print-footer" style={{ marginTop: "auto" }}>
            <p
              style={{
                margin: 0,
                fontSize: "8.5px",
                color: "#000000",
                letterSpacing: "0.3px",
              }}
            >
              Powered by PerennialCode
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Indent;
